import { render, staticRenderFns } from "./RoleDrawerScopedSwitch.vue?vue&type=template&id=6597c9c5&scoped=true&"
import script from "./RoleDrawerScopedSwitch.vue?vue&type=script&lang=js&"
export * from "./RoleDrawerScopedSwitch.vue?vue&type=script&lang=js&"
import style0 from "./RoleDrawerScopedSwitch.vue?vue&type=style&index=0&id=6597c9c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6597c9c5",
  null
  
)

export default component.exports